const notes = {
  title: 'Titel',
  details: 'Details',
  content: 'Inhalt',
  showForm: 'Neue Notiz',
  to: { label: 'Bis', validation: 'Bis ist erforderlich' },
  addNote: 'Hinzufügen',
  cancel: 'Stornieren',
  save: 'Speichern',
  createdAt: 'Created At: ',
  createdBy: 'Created By: ',
  noteType: 'Note Type ',
  typeNewNote: 'Geben Sie eine neue Notiz ein É',
  dropDownIcons: {
    pinToTop: 'Oben anheften',
    unpinFromTop: 'Von oben lösen',
    EditUpdate: 'Update bearbeiten',
    DeleteUpdate: 'Update für alle löschen',
  },
  edit: {
    toast: {
      error: {
        delete: 'Hinweis wurde nicht entfernt',
        add: 'Hinweis nicht hinzugefügt',
        update: 'Hinweis wurde nicht aktualisiert',
        pin: 'Notiz wurde oben nicht angeheftet',
        unpin: 'Notiz wurde oben nicht gelöst gelöst',
      },
    },
  },
};

export default notes;
